import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

const sections = [
  ["Acceptance of Terms", "By using Nirmantra.ai, you agree to these Terms & Conditions. If you do not agree, please do not use the platform."],
  ["Nature of Service", "Nirmantra.ai is an independent advisory platform. We are not a contractor, builder or architect. Our AI Construction Health Reports and expert consultations are advisory in nature and intended to support — not replace — professional engineering, legal or architectural judgement."],
  ["No Guarantee of Outcomes", "Cost estimates, savings figures and risk assessments are based on the information you provide and prevailing market rates. They are planning benchmarks and do not constitute a guarantee of actual construction costs or outcomes."],
  ["User Responsibilities", "You are responsible for the accuracy of the documents and details you upload, and for all construction decisions you make. Always verify critical decisions with licensed professionals."],
  ["Consultations", "Expert consultations are advisory. Nirmantra.ai advisors are independent and do not undertake construction work. Bookings are subject to advisor availability."],
  ["Intellectual Property", "All platform content, branding and software are the property of Nirmantra.ai. Your uploaded documents remain your property."],
  ["Limitation of Liability", "To the maximum extent permitted by law, Nirmantra.ai is not liable for any direct or indirect losses arising from reliance on reports, estimates or advice provided through the platform."],
  ["Changes to Terms", "We may update these terms from time to time. Continued use of the platform constitutes acceptance of the updated terms."],
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNav />
      <main className="max-w-3xl mx-auto px-6 py-16 lg:py-20">
        <h1 className="font-display text-4xl lg:text-5xl tracking-tighter font-extrabold text-slate-900">Terms &amp; Conditions</h1>
        <p className="mt-3 text-slate-500">Last updated: June 2026</p>
        <div className="mt-10 space-y-8">
          {sections.map(([t, d], i) => (
            <div key={i}>
              <h2 className="font-display text-xl font-bold text-slate-900">{t}</h2>
              <p className="mt-2 text-slate-600 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
